import { lazy } from "react";

import { RoutePathBuilder } from "@/common/builders/routePath";
import AuthorizedRoute from "@/common/components/Auth/AuthorizedRoute";
import { Loadable } from "@/common/components/Loadable";
import { ROUTE_PATH } from "@/common/constants/routing";
import { AppPermission } from "@/core/api/generated/v1";

const VehicleVisualModelViewPage = Loadable(
  lazy(
    () => import("../../MainAppView/ReferenceData/VehicleVisualModels/VehicleVisualModelViewPage"),
  ),
);
const VehicleVisualModelsPage = Loadable(
  lazy(() => import("../../MainAppView/ReferenceData/VehicleVisualModels/VehicleVisualModelsPage")),
);
export function ReferenceDataRoutes() {
  return (
    <>
      {/* VehicleVisualModel */}
      <AuthorizedRoute
        permissions={[AppPermission.FleetAppAccess]}
        exact
        path={RoutePathBuilder.toDefinition(ROUTE_PATH.VEHICLE_VISUAL_MODELS)}
        render={() => <VehicleVisualModelsPage />}
      />
      <AuthorizedRoute
        permissions={[AppPermission.FleetAppAccess]}
        exact
        path={RoutePathBuilder.toDefinition(ROUTE_PATH.VEHICLE_VISUAL_MODEL_VIEW())}
        render={() => <VehicleVisualModelViewPage />}
      />
    </>
  );
}
